import { CopyOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SyncOutlined } from "@ant-design/icons";
import { useRestAPI } from "@src/frontend/hooks/useRestAPI";
import { Button, Drawer, Flex, Form, Popconfirm, Space, Table, Tag, Typography } from "antd";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { ResourceEditForm, type FormData } from "./components/ResourceEditForm";
import type { ScriptResourceModel } from "@src/generated/prisma/models";

const StyledComponent = styled(Flex)``;


export const ResourcePage = () => {
  const { listReq, updateReq, delReq, createReq } = useRestAPI<ScriptResourceModel>('/api/resources');
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const handleCreate = useCallback(() => {
    form.resetFields();
    setOpen(true);
  }, []);

  const handleSubmit = useCallback(async (data: Partial<FormData>) => {
    console.debug('Submit', data);
    if (data.id) {
      await updateReq.runAsync(data, data.id);
    } else {
      await createReq.runAsync(data);
    }
    await listReq.runAsync();
    setOpen(false);
  }, []);

  return (
    <StyledComponent className="page-shell" vertical gap={12}>
      <Flex className="page-header" vertical>
        <Typography.Text className="page-eyebrow">VARIABLES</Typography.Text>
        <Typography.Title level={2} className="page-title">资源变量</Typography.Title>
        <Typography.Text type="secondary">集中保存脚本所需的 URL、账号与动态参数。</Typography.Text>
      </Flex>
      <Flex gap={8}>
        <Button size="large" block type={listReq.data?.data?.length ? 'dashed' : 'primary'} onClick={handleCreate} icon={<PlusOutlined />}>创建资源</Button>
        <Button size="large" onClick={listReq.runAsync}>
          <SyncOutlined />
        </Button>
      </Flex>
      <Table
        size="small"
        rowKey={e => e.id}
        dataSource={listReq.data?.data ?? []}
        scroll={{ x: 600 }}
        onRow={record => ({
          onDoubleClick: () => {
            form.setFieldsValue(record);
            setOpen(true);
          }
        })}
        columns={[
          { width: 300, dataIndex: 'name', title: '资源名称', render: name => <Typography.Text strong>{name}</Typography.Text> },
          { dataIndex: 'data', title: '变量摘要', render: data => {
            const entries = data ?? [];
            return <Flex gap={6} wrap>{entries.slice(0, 4).map((item: { key: string }) => <Tag key={item.key}>{item.key}</Tag>)}{entries.length > 4 && <Tag>+{entries.length - 4}</Tag>}</Flex>;
          } },
          { width: 180, align: 'right', dataIndex: 'id', title: '操作', render: (id, data) => {
            return (
              <Flex justify="center" gap={12}>
                <Space.Compact size="small">
                  <Button onClick={() => {
                    const { name, data: _data } = data;
                    handleSubmit({ name: `${name} - copy`, data: _data });
                  }}>
                    <CopyOutlined />
                  </Button>
                  <Button onClick={() => {
                    form.setFieldsValue(data);
                    setOpen(true);
                  }}>
                    <EditOutlined />
                  </Button>
                </Space.Compact>
                <Popconfirm
                  title='删除？'
                  description='此操作无法恢复'
                  okButtonProps={{ danger: true }}
                  okText='删除'
                  cancelText='取消'
                  onConfirm={async () => {
                    await delReq.runAsync(id);
                    await listReq.runAsync();
                  }}
                >
                  <Button danger size="small"><DeleteOutlined /></Button>
                </Popconfirm>
              </Flex>
            );
          }}
        ]}
      />
      <Drawer
        open={open}
        size={600}
        mask={{ closable: false }}
        title={form.getFieldsValue().name || '新建资源变量'}
        onClose={() => setOpen(false)}
      >
        <ResourceEditForm form={form} onSubmit={handleSubmit} />
      </Drawer>
    </StyledComponent>
  );
}
